import React, { useEffect, useState } from 'react';
import { PhotoProvider } from 'react-photo-view';
import { Link } from 'react-router-dom';
import Service from './Service/Service';

const Services = () => {
    const [foods, setfoods] = useState([]);
    useEffect(() => {
        fetch('https://salma-kitchen-server.vercel.app/foods/limit/3')
            .then(res => res.json())
            .then(data => setfoods(data));
    }, []);

    return (
        <div className='bg-base-300 py-16 px-5 lg:px-24'>
            <h1 className="text-center text-5xl font-bold">My Services</h1>
            <div className="service-card-container grid sm:grid-cols-1 md:grid-cols-3 gap-10 pt-12">
                <PhotoProvider>
                {
                    foods.map(food => <Service key={food._id} food={food} ></Service>)
                }
                </PhotoProvider>
            </div>
            <div className='text-center mt-6'>
                <Link to={'/foods'}><button className="btn">Show All</button></Link>
            </div>
        </div>
    );
};

export default Services;